import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import { StyledAppBar } from './Navbar.style';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import logo from '../../assets/images/alrabie_logo.png';
import FacebookTwoToneIcon from '@mui/icons-material/FacebookTwoTone';
import LanguageIcon from '@mui/icons-material/Language';

{
  /* <Route path="/applications" element={<Applications />} /> */
}
const pages = [
  { name: 'navigation.home', path: '/' },
  { name: 'navigation.about', path: '/about' },
  { name: 'navigation.contact', path: '/contact' },
  { name: 'navigation.products', path: '/products' },
  { name: 'navigation.applications', path: '/applications' },
];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const Navbar = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElLang, setAnchorElLang] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenLangMenu = (event) => {
    setAnchorElLang(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseLangMenu = () => {
    setAnchorElLang(null);
  };

  const handleNavigation = (path) => {
    navigate(path);
    handleCloseNavMenu();
  };

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    handleCloseLangMenu();
    // Add RTL support for Arabic
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  };

  return (
    <AppBar
      position="sticky"
     sx={{
      top: 0,
      zIndex: (theme) => theme.zIndex.drawer + 1,
      boxShadow: 'none',
      backgroundColor: '#f7f1ee',
      marginBottom: '40px',
    }}
      dir={ i18n.language === 'ar' ? 'rtl' : 'ltr'}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ minHeight: '85px !important' }}>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}>
            <img
              src={logo}
              alt="nana-logo"
              width="100"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/')}
            />
          </Box>
          <Box
            sx={{
              minHeight: '85px !important',
              flexGrow: 1,
              display: { xs: 'flex', md: 'none' },
            }}
          >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  sx={{ color: 'rgb(154,74,32)' }}
                  key={page.name}
                  onClick={() => handleNavigation(page.path)}
                >
                  <Typography textAlign="center">{t(page.name)}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          {/* <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, mr: 1 }}>
             <img src={logo} alt='nana-logo' width='100' /> 
            <IconButton>
             <FacebookTwoToneIcon/>
            </IconButton>
            <IconButton>
             <FacebookTwoToneIcon/>
            </IconButton>
            <IconButton>
             <FacebookTwoToneIcon/>
            </IconButton>
          </Box> */}

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page.name}
                onClick={() => handleNavigation(page.path)}
                sx={{
                  my: 1,
                  display: 'block',
                  color: 'rgb(154,74,32)',
                  fontWeight: 500,
                  fontSize: i18n.language === 'ar' ? '19px' : '14px',
                }}
              >
                {t(page.name)}
              </Button>
            ))}
          </Box>

          <Box
            sx={{ flexGrow: 0, display: 'flex', alignItems: 'center', gap: 2 }}
          >
            <Button
              onClick={handleOpenLangMenu}
              size="large"
              sx={{
                minWidth: 'auto',
                padding: '6px 12px',
                borderRadius: '8px',
                color: 'rgb(154,74,32)',
                fontWeight: 500,
                '& .MuiButton-startIcon': {
                  marginRight: i18n.language === 'ar' ? '8px' : '4px',
                  marginLeft: i18n.language === 'ar' ? '4px' : '0px',
                },
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
              startIcon={<LanguageIcon />}
            >
              {/* {i18n.language.toUpperCase()} */}
            </Button>
            <Menu
              id="language-menu"
              anchorEl={anchorElLang}
              open={Boolean(anchorElLang)}
              onClose={handleCloseLangMenu}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem onClick={() => handleLanguageChange('en')}>
                <Typography
                  textAlign="center"
                  sx={{ color: 'rgb(154,74,32)', fontWeight: 500 }}
                >
                  English
                </Typography>
              </MenuItem>
              <MenuItem onClick={() => handleLanguageChange('ar')}>
                <Typography
                  textAlign="center"
                  sx={{ color: 'rgb(154,74,32)', fontWeight: 500 }}
                >
                  العربية
                </Typography>
              </MenuItem>
            </Menu>

            <Button
              size="large"
              variant="outlined"
              sx={{
                color: 'rgb(154,74,32)',
                padding: {
                  xs: '2px 10px',
                  md: '10px 15px',
                },
                borderRadius: '20px',
                borderColor: 'rgb(154,74,32)',
                '&:hover': {
                  borderColor: 'rgb(134,54,12)',
                  color: 'rgb(134,54,12)',
                  backgroundColor: 'rgba(154,74,32,0.04)',
                },
              }}
              onClick={() => navigate('/request-quote')}
            >
              {t('navigation.requestQuote')}
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
